export function arrayEquals(a, b) {
  return Array.isArray(a) &&
          Array.isArray(b) &&
          a.length === b.length &&
          a.every((val, index) => val === b[index]);
}

export function deepCopy(arrSrc) {
  const arrDest = arrSrc.slice()
  for(let ix = 0; ix < arrDest.length; ix++) {
    arrDest[ix] = {...arrSrc[ix]}
  }
  return arrDest
}

export function deepCopyExcludingField(arrSrc, fieldName) {
  const arrDest = arrSrc.slice()
  for(let ix = 0; ix < arrDest.length; ix++) {
    arrDest[ix] = {...arrSrc[ix]}
    delete arrDest[ix][fieldName]
  }
  return arrDest
}

export function deepCopySyncDecimalStringField(arrSrc, fieldName) {
  const arrDest = arrSrc.slice()
  for(let ix = 0; ix < arrDest.length; ix++) {
    arrDest[ix] = {...arrSrc[ix]}
    arrDest[ix][`${fieldName}Str`] = `${arrDest[ix][fieldName]}`
  }
  return arrDest
}

export function getFieldValuesAsUniqueArray(arrSrc, fieldName, transformFn) {
  if (!arrSrc || arrSrc.length === 0) {
    return []
  }
  let arrWithDups = arrSrc.map((o) => transformFn ? transformFn(o[fieldName]) : o[fieldName])
  return [...new Set(arrWithDups)]
}

export function setArrayFieldValues(arrSrc, fieldName, value) {
  if (arrSrc === undefined) {
    return
  }
  arrSrc.forEach(function (item) {
    item[fieldName] = value
  })
}

export function getSumForField(arrSrc, fieldName, transformFn) {
  if (arrSrc === undefined) {
    return 0
  }
  if (transformFn === undefined) {
    return arrSrc.reduce((acc, obj) => {return acc + obj[fieldName]}, 0)
  }
  return arrSrc.reduce((acc, obj) => {return acc + transformFn(obj[fieldName])}, 0)
}

export function findIndexForFieldValue(arrSrc, key, value) {
  return arrSrc.findIndex((obj) => obj[key] === value)
}

export function findObjectForFieldValue(arrSrc, key, value) {
  return arrSrc.find((obj) => obj[key] === value)
}

export function arrayHasIntersectionIgnoreCase(arrSrcLowerCase, arrCandidate) {
  if (arrSrcLowerCase?.length > 0 && !arrCandidate?.length) {
    return false;
  }
  if (arrSrcLowerCase?.length > 0) {
    for(const item of arrCandidate) {
      if (arrSrcLowerCase.includes(item.toLowerCase())) {
        return true;
      }
    }
  }
  return false;
}

export function sortOnStringField(a, b, sortField) {
  const fieldA = a[sortField].toUpperCase()
  const fieldB = b[sortField].toUpperCase()
  return fieldA < fieldB ? -1 : (fieldA > fieldB ? 1 : 0)
}